import {
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from '@vue/composition-api';

export default function useGroupBannerInformation(props) {
  const vm = getCurrentInstance().proxy;

  const form = reactive({
    name: null,
    description: null,
    status: 0,
    isDefault: false,
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
  });

  const statusProperty = reactive({
    label_en: 'Status',
    label_th: 'Status',
    value: false,
    field_property: {
      font_size: '20px',
      mode: 2,
      value: [
        {
          item_id: 1,
          name_th: 'Offline',
          name_en: 'Offline',
          label_th: 'Inactive',
          label_en: 'Inactive',
          font_size: '20px',
          color_icon: '#AAAAAA',
          color_font: '#AAAAAA',
          value: false,
        },
        {
          item_id: 2,
          name_th: 'Online',
          name_en: 'Online',
          label_th: 'Active',
          label_en: 'Active',
          color_icon: '#00C965',
          color_font: null,
          font_size: '20px',
          value: true,
        },
      ],
    },
  });

  const flatpickrDateConfig = reactive({
    allowInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'd-m-Y',
    minDate: null,
    onReady: function(selectedDates, dateStr, instance) {
      let el = instance.element;

      const preventInput = (event) => {
        event.preventDefault();
        return false;
      };

      el.onkeypress = preventInput;
      el.onkeydown = preventInput;
      el.onkeyup = preventInput;
      el.onpaste = preventInput;
      el.style.caretColor = 'transparent';
      el.style.cursor = 'pointer';
    },
  });

  const flatpickrTimeConfig = reactive({
    allowInput: true, // prevent "readonly" prop
    enableTime: true,
    noCalendar: true,
    dateFormat: 'H:i',
    minTime: null,
    time_24hr: true,
    minuteIncrement: 1,
    onReady: function(selectedDates, dateStr, instance) {
      let el = instance.element;

      const preventInput = (event) => {
        event.preventDefault();
        return false;
      };

      el.onkeypress = preventInput;
      el.onkeydown = preventInput;
      el.onkeyup = preventInput;
      el.onpaste = preventInput;
      el.style.caretColor = 'transparent';
      el.style.cursor = 'pointer';
    },
  });

  const onOpenValidFromDatePicker = () => {
    flatpickrDateConfig.minDate = null;
  };

  const onSelectValidFromDate = () => {
    if (form.validThrough.date) {
      const validThroughDate = new Date(
        resolveDateString(form.validThrough.date)
      );

      const validFromDate = new Date(resolveDateString(form.validFrom.date));

      if (validFromDate > validThroughDate) {
        form.validThrough.date = null;
        form.validThrough.time = null;
      }
    }

    flatpickrDateConfig.minDate = form.validFrom.date;
  };

  const onOpenValidFromTimePicker = () => {
    flatpickrTimeConfig.minTime = null;
  };

  const onOpenValidThroughTimePicker = () => {
    if (form.validFrom.date == form.validThrough.date) {
      flatpickrTimeConfig.minTime = form.validFrom.time;
    }
  };

  const onSelectValidFromTimePicker = () => {
    if (
      form.validFrom.date == form.validThrough.date &&
      form.validFrom.time > form.validThrough.time
    ) {
      form.validThrough.time = null;
    }
  };

  const resolveDateString = (dateString) => {
    const date = dateString.split('-');

    const resolvedDate = `${date[2]}-${date[1]}-${date[0]}`;

    return resolvedDate;
  };

  const resolveDate = (dateInput) => {
    const date = new Date(dateInput);

    try {
      const dateStr = `${date.toLocaleString('default', {
        day: '2-digit',
      })}-${date.toLocaleString('default', {
        month: '2-digit',
      })}-${date.getFullYear()}`;

      return dateStr;
    } catch (err) {
      return '';
    }
  };

  const resolveTime = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();

      const timeStr = `${hours < 10 ? `0${hours}` : hours}:${
        minutes < 10 ? `0${minutes}` : minutes
      }`;

      return timeStr;
    } catch (err) {
      return '';
    }
  };

  const onToggleStatus = () => {
    const status = vm.$refs.statusToggle;

    form.status = status.fieldValue ? 1 : 0;
  };

  const initInformation = (information) => {
    form.name = information.name;
    form.description = information.description;
    form.validFrom.date = information.validFrom
      ? resolveDate(information.validFrom)
      : null;
    form.validFrom.time = information.validFrom
      ? resolveTime(information.validFrom)
      : null;
    form.validThrough.date = information.validThrough
      ? resolveDate(information.validThrough)
      : null;
    form.validThrough.time = information.validThrough
      ? resolveTime(information.validThrough)
      : null;
    form.status = information.status ? 1 : 0;
    form.isDefault = information.isDefault;
    statusProperty.value = information.status;
  };

  onBeforeMount(() => {
    initInformation(JSON.parse(JSON.stringify(props.groupBannerInformation)));
  });

  watch(
    () => props.groupBannerInformation,
    (newVal, oldVal) => {
      initInformation(JSON.parse(JSON.stringify(props.groupBannerInformation)));
    },
    { deep: true }
  );

  return {
    statusProperty,
    form,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onSelectValidFromDate,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromTimePicker,
    onToggleStatus,
  };
}
